module.exports = __webpack_public_path__ + "static/media/pf_item_17.f340bf97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pf_item_17.jpg
// module id = 202
// module chunks = 0